// Afwerkingen die een klant zelf moet aanzetten. Print.com levert per product
// een voorbeeldconfiguratie (`specifications.defaultOptions`) waarin deze
// vaak al aan staan: bij flyers op vorm snijden, een boorgat, een
// perforatielijn, nummering en afgeronde hoeken. Als startkeuze leverde dat
// een veel te hoge prijs (EUR 285 voor 1 flyer) of een combinatie zonder prijs.
export const OPT_IN_ADDON_OPTION_IDS = new Set([
  'die_cut',
  'perforation',
  'personalize',
  'drillholes',
  'rounded_corners',
  'variable_creasing_line',
  'spot_finish',
  'spot_finish_back',
  'sealed',
]);

const NONE_VALUES = new Set(['none', 'no', 'geen', 'false']);

type AddonOption = {
  id: string;
  required?: boolean;
  locked?: boolean;
  default?: string | number;
  values?: Array<{ value: string | number; nullable?: boolean }>;
};

/**
 * Geeft de startwaarde voor een optie terug, met betaalde afwerkingen uit de
 * leveranciersvoorbeeldconfiguratie vervangen door de "geen"-waarde van de
 * optie. `undefined` betekent: de optie weglaten (Print.com leest dat als geen).
 */
export function sanitizeOptInAddonDefault(
  optionId: string,
  catalogValue: string | number | undefined,
  options: AddonOption[],
): string | number | undefined {
  if (catalogValue === undefined || !OPT_IN_ADDON_OPTION_IDS.has(optionId)) return catalogValue;
  if (NONE_VALUES.has(String(catalogValue).toLowerCase())) return catalogValue;

  const option = options.find((candidate) => candidate.id === optionId);
  // Vergrendeld = de leverancier vereist deze afwerking voor dit product: een
  // hangtag heeft een boorgat nodig voor het koord, een waaierkaart voor de
  // schroef. "Geen" gaf daar nooit een prijs (19 okt: 125x op hangtags).
  if (!option || option.required || option.locked) return catalogValue;

  const noneValue = option.values?.find((value) => value.nullable)?.value
    ?? option.values?.find((value) => NONE_VALUES.has(String(value.value).toLowerCase()))?.value;
  if (noneValue !== undefined) return noneValue;

  if (option.default !== undefined && NONE_VALUES.has(String(option.default).toLowerCase())) return option.default;
  return undefined;
}
